import React from 'react';
import { Container, Row, Col, Card, Image, Badge } from 'react-bootstrap';
import { useSelector } from "react-redux";

import profilePic from 'assets/images/profile.jpg';
import { formatDate } from 'utils/date';

const ProfileViewManagement = () => {

  const { userInfo: loggedUserInfo, } = useSelector((state) => state.auth);
  
  return (
    <section className="section dashboard">
      <Container>
        {/* Placeholder logic: assume profile is loaded iff loggedUserInfo?.employeeId exists */}
        {!loggedUserInfo?.employeeId ? (
          <>
            <Row className="mt-lg-5">
              <Col lg={6}>
                <div className="single-profile d-flex align-items-center">
                  <div className="all-e-img">
                    <span className="placeholder placeholder-lg rounded-circle" style={{ width: 120, height: 120, display: "block" }}></span>
                  </div>
                  <div className="single-con w-100 mx-4">
                    <h4><span className="placeholder col-7 placeholder-lg"></span></h4>
                    <p><span className="placeholder col-4"></span></p>
                    <p><span className="placeholder col-4"></span></p>
                    <p><span className="placeholder col-5"></span></p>
                    <p><span className="placeholder col-6"></span></p>
                  </div>
                </div>
              </Col>
            </Row>
            <hr />
            <Row className="mt-lg-5">
              <Col lg={6}>
                <Card>
                  <Card.Body className="pt-3">
                    <span className="placeholder placeholder-lg col-5 mb-4 d-block"></span>
                    <table className="table table-striped table-bordered table-fixed m-0">
                      <tbody>
                        <tr>
                          <td>
                            <span className="placeholder col-3 d-block mb-2"></span>
                          </td>
                          <td>
                            <span className="placeholder col-6 d-block mb-2"></span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span className="placeholder col-4 d-block mb-2"></span>
                          </td>
                          <td>
                            <span className="placeholder col-5 d-block mb-2"></span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span className="placeholder col-4 d-block"></span>
                          </td>
                          <td>
                            <span className="placeholder col-5 d-block"></span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span className="placeholder col-6 d-block"></span>
                          </td>
                          <td>
                            <span className="placeholder col-4 d-block"></span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </Card.Body>
                </Card>
              </Col>
              <Col lg={6}>
                <Card>
                  <Card.Body className="pt-3">
                    <span className="placeholder placeholder-lg col-6 mb-4 d-block"></span>
                    <table className="table table-striped table-bordered table-fixed m-0">
                      <tbody>
                        <tr>
                          <td>
                            <span className="placeholder col-3 d-block mb-2"></span>
                          </td>
                          <td>
                            <span className="placeholder col-8 d-block mb-2"></span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span className="placeholder col-4 d-block mb-2"></span>
                          </td>
                          <td>
                            <span className="placeholder col-7 d-block mb-2"></span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span className="placeholder col-5 d-block"></span>
                          </td>
                          <td>
                            <span className="placeholder col-5 d-block"></span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </>
        ) : (
          <>
            <Row className="mt-lg-5">
              <Col>
                <div className="single-profile d-flex align-items-center">
                  <div className="all-e-img">
                    <Image
                      src={
                        loggedUserInfo?.biometricDetails?.profilePicture?.length > 0
                          ? loggedUserInfo.biometricDetails.profilePicture
                          : profilePic
                      }
                      onError={e => {
                        e.target.src = profilePic;
                      }}
                      alt="Profile"
                    />
                  </div>
                  <div className="single-con mx-4">
                    <h4>{loggedUserInfo?.name}</h4>
                    <p><i>{loggedUserInfo?.designation?.name}</i></p>
                    <p><b>Team: </b><i>{loggedUserInfo?.team?.name}</i></p>
                    <p><b>Date of Joining: </b>{formatDate(loggedUserInfo?.dateOfJoining, 'dd LLL, yyyy')}</p>
                    <p><b>Employee ID: </b>{loggedUserInfo?.employeeId}</p>
                  </div>
                </div>
              </Col>
            </Row>
            <hr />
            <Row className="mt-lg-5">
              <Col lg={6}>
                <Card>
                  <Card.Body>
                    <h5 className="pt-3 mb-3">Personal Details</h5>
                    <table className="table table-striped table-bordered table-fixed m-0">
                      <tbody>
                        <tr>
                          <th>Phone</th>
                          <td>{loggedUserInfo?.phone ? <a href={`tel:+91${loggedUserInfo.phone}`}>{"+91 " + loggedUserInfo.phone}</a> : <Badge bg="warning" text="dark">Pending</Badge>}</td>
                        </tr>
                        <tr>
                          <th>Email</th>
                          <td>{loggedUserInfo?.email ? <a href={`mailto:${loggedUserInfo.email}`}>{loggedUserInfo.email}</a> : <Badge bg="warning" text="dark">Pending</Badge>}</td>
                        </tr>
                        <tr>
                          <th>Date of Birth</th>
                          <td>{formatDate(loggedUserInfo?.dateOfBirth, 'dd LLL, yyyy')}</td>
                        </tr>
                        <tr>
                          <th>Address</th>
                          <td>{loggedUserInfo?.address ? loggedUserInfo.address : <Badge bg="warning" text="dark">Pending</Badge>}</td>
                        </tr>
                      </tbody>
                    </table>
                  </Card.Body>
                </Card>
              </Col>
              <Col lg={6}>
                <Card>
                  <Card.Body>
                    <h5 className="pt-3 mb-3">Salary Account Details</h5>
                    <table className="table table-striped table-bordered table-fixed m-0">
                      <tbody>
                        <tr>
                          <th>Bank Name</th>
                          <td>
                            {loggedUserInfo?.bankDetails?.bankName ? loggedUserInfo.bankDetails.bankName : <Badge bg="warning" text="dark">Pending</Badge>}
                          </td>
                        </tr>
                        <tr>
                          <th>Account Number</th>
                          <td>
                            {loggedUserInfo?.bankDetails?.accountNumber ? loggedUserInfo.bankDetails.accountNumber : <Badge bg="warning" text="dark">Pending</Badge>}
                          </td>
                        </tr>
                        <tr>
                          <th>IFSC Code</th>
                          <td>
                            {loggedUserInfo?.bankDetails?.ifscCode ? loggedUserInfo.bankDetails.ifscCode : <Badge bg="warning" text="dark">Pending</Badge>}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </>
        )}
      </Container>
    </section>
  );
};

export default ProfileViewManagement;